<template>
    <div class="page">
        <div class="list">
            <div class="list-item" v-for="item in images" :key="item.img">
                <img  v-if="item.link" :src="item.img" alt="" @click="openBrowser">
                <img :src="item.img" alt="" v-else>
            </div>
        </div>
    </div>
</template>

<script>
import AppLink from '@/components/Link'
import { invokeNative } from '@/utils/hybrid'
export default {
    name: "valentinesDay",
    components:{AppLink},
    data(){
        return{
            images:[
                {img:require('@/assets/images/LateMarch/1.png'),link:''},
                {img:require('@/assets/images/LateMarch/2.png'),link:''},
                {img:require('@/assets/images/LateMarch/3.png'),link:''},
                {img:require('@/assets/images/LateMarch/4.png'),link:'https://www.facebook.com/ReaderStudio2022/?ref=pages_you_manage'}
            ]
        }
    },
    methods:{
        openBrowser(){
            const action = 'goToBrowser'
            const params = {
                url: 'https://www.facebook.com/ReaderStudio2022'
            }
            invokeNative(params, action)
        }
    }
};
</script>

<style scoped>
.list-item{
    display:block;
    font-size:0;
img{
    width:100%;
    display:block;
}
}
</style>
